import {
  formatLeaveDays,
  halfDayPeriodLabel,
  LeaveRequest,
  leaveStatusClass,
  leaveStatusLabel,
  leaveTypeLabel,
} from '../../../types/leaveRequest';
import { formatDate } from './previewShared';
import '../../mypage/LeaveRequestPanel.css';

interface Props {
  detail: LeaveRequest;
}

function LeavePreviewView({ detail }: Props) {
  return (
    <article className="leave-panel__detail">
      <div className="leave-panel__detail-head">
        <div>
          <span
            className={`leave-panel__status is-${leaveStatusClass(
              detail.status,
              detail.approvalInProgress
            )}`}
          >
            {leaveStatusLabel(detail.status, detail.approvalInProgress)}
          </span>
          <h3>
            {leaveTypeLabel(detail.leaveType)}
            {detail.leaveType === 'HALF'
              ? ` (${halfDayPeriodLabel(detail.halfDayPeriod)})`
              : ''}{' '}
            · {formatDate(detail.startDate)} ~ {formatDate(detail.endDate)}
          </h3>
          <p>
            {detail.requesterName || '-'} · {formatLeaveDays(detail.days)}일
            {detail.approverName ? ` · 승인자 ${detail.approverName}` : ''}
            {detail.balanceApplied ? ' · 연차 차감됨' : ''}
          </p>
        </div>
      </div>
      <dl className="leave-panel__meta">
        <div>
          <dt>유형</dt>
          <dd>
            {leaveTypeLabel(detail.leaveType)}
            {detail.leaveType === 'HALF'
              ? ` · ${halfDayPeriodLabel(detail.halfDayPeriod)}`
              : ''}
          </dd>
        </div>
        <div>
          <dt>기간</dt>
          <dd>
            {formatDate(detail.startDate)} ~ {formatDate(detail.endDate)}
          </dd>
        </div>
        <div>
          <dt>일수</dt>
          <dd>{formatLeaveDays(detail.days)}</dd>
        </div>
        <div>
          <dt>사유</dt>
          <dd className="is-reason">{detail.reason || '-'}</dd>
        </div>
      </dl>
    </article>
  );
}

export default LeavePreviewView;
